import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";


const ChatbotScript02 = () => {
  const location = useLocation();
  return (
     <>
     
    </>
     
  );
};

export default ChatbotScript02;
